import { render, staticRenderFns } from "./levelDesc.vue?vue&type=template&id=a6c6d1b4&scoped=true"
import script from "./levelDesc.vue?vue&type=script&lang=js"
export * from "./levelDesc.vue?vue&type=script&lang=js"
import style0 from "./levelDesc.vue?vue&type=style&index=0&id=a6c6d1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c6d1b4",
  null
  
)

export default component.exports